import baseUrl from "../config/baseUrl";

const deleteContractTemplates = async ({ token, id }) => {
    const formData = new FormData();
    formData.append("id", id);

    try {
        const response = await fetch(
            `${baseUrl}/api/delete-contract-request-setting-data?contract_request_setting_id=${id}`,
            {
                method: "Delete",
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: formData,
            }
        );
        const data = await response.json();
        return data;
    } catch (error) {
        return error;
    }
};

export default deleteContractTemplates;
